export default "__VITE_ASSET__0f560ba6__"